/**
 * Originals CBD - Cart Drawer Optimistic Updates
 *
 * Dawn's QuantityInput fires a `change` event (bubbles:true) after stepUp/stepDown.
 * We intercept that same event - synchronously, before Dawn's 150ms debounce -
 * and update line prices, subtotal and delivery bar immediately.
 */

(function () {
  'use strict';

  const FREE_DELIVERY_THRESHOLD = 7000; // pence - must match cart-drawer.liquid

  function formatMoney(pence) {
    return '£' + (pence / 100).toFixed(2);
  }

  function updateDeliveryBar(totalPence) {
    const bar = document.querySelector('.drawer__delivery-bar');
    if (!bar) return;
    const fill = bar.querySelector('.drawer__delivery-fill');
    const msg  = bar.querySelector('.drawer__delivery-msg');
    if (!fill || !msg) return;

    const progress = Math.min((totalPence / FREE_DELIVERY_THRESHOLD) * 100, 100);
    fill.style.width = progress + '%';

    const truckSvg = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="3" width="15" height="13"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';

    if (totalPence >= FREE_DELIVERY_THRESHOLD) {
      msg.innerHTML = truckSvg + " You've unlocked <strong>free delivery!</strong>";
      msg.classList.add('drawer__delivery-msg--achieved');
    } else {
      const remaining = FREE_DELIVERY_THRESHOLD - totalPence;
      msg.innerHTML = truckSvg + ' <strong>' + formatMoney(remaining) + '</strong> away from free delivery';
      msg.classList.remove('drawer__delivery-msg--achieved');
    }
  }

  function recalcFromRow(changedRow) {
    const unitPrice = parseInt(changedRow.dataset.unitPrice, 10) || 0;
    const input     = changedRow.querySelector('.quantity__input');
    const qty       = input ? (parseInt(input.value, 10) || 0) : 0;

    const priceEl = changedRow.querySelector('.cart-item__price-wrapper .price--end') ||
                    changedRow.querySelector('.cart-item__price-wrapper .price');
    if (priceEl) priceEl.textContent = formatMoney(unitPrice * qty);

    let total = 0;
    document.querySelectorAll('#CartDrawer .cart-item[data-unit-price]').forEach((row) => {
      const up  = parseInt(row.dataset.unitPrice, 10) || 0;
      const inp = row.querySelector('.quantity__input');
      const q   = inp ? (parseInt(inp.value, 10) || 0) : 0;
      total += up * q;
    });

    const subtotalEl = document.querySelector('#CartDrawer .totals__total-value');
    if (subtotalEl) subtotalEl.textContent = formatMoney(total);

    updateDeliveryBar(total);
  }

  function onCartChange(event) {
    const input = event.target;
    if (!input || !input.classList.contains('quantity__input')) return;
    if (!input.closest('#CartDrawer')) return;
    const row = input.closest('.cart-item[data-unit-price]');
    if (!row) return;
    recalcFromRow(row);
  }

  // `change` bubbles from QuantityInput's dispatchEvent(this.changeEvent)
  // capture phase - fires before Dawn's debounced listener
  document.addEventListener('change', onCartChange, true);

})();
